import http from "@/utils/request";

/** @description 账号密码登录 */
export const accountLogin = (params: any) => http.post("/user/login", params);

/** @description 短信登录 */
export const smsLogin = (params: any) => http.post("/user/login/sms", params);

/** @description 重置密码 */
export const resetPassword = (params: any) => http.post("/user/reset_password", params);

/** @description 获取用户信息 */
export const userInfoApi = () => http.get("/user/info");

/** @description 修改用户头像 */
export const modifyUserAvatar = (params: any) => http.put("/user/avatar", params);
